import { toEmbedUrl } from "@/lib/videoEmbed";
import RichText from "@/components/RichText";
import CtaButtonBlocks, { ctaButtonBlocks } from "./CtaButtonBlocks";

// Valeurs par défaut identiques à theme_service.DEFAULT_PROPS["video_banner"]
// — voir HeroSection.jsx pour l'explication du repli.
const DEFAULTS = {
  heading: "Votre titre ici",
  video_url: "",
  poster_image: "",
  autoplay: "false",
  loop: "true",
};

export default function VideoBannerSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const autoplay = t.autoplay === "true" || t.autoplay === true;
  const loop = t.loop === "true" || t.loop === true;
  const embed = toEmbedUrl(t.video_url, { autoplay, loop });
  const extraButtons = ctaButtonBlocks(blocks);

  return (
    <section className="relative min-h-[440px] flex items-center justify-center text-center px-6 overflow-hidden bg-ink">
      {embed && (
        <div className="absolute inset-0">
          {embed.kind === "iframe" ? (
            <iframe
              src={embed.src}
              title="Vidéo"
              allow="autoplay; fullscreen; picture-in-picture"
              className="w-full h-full object-cover pointer-events-none scale-125"
            />
          ) : (
            <video
              src={embed.src}
              poster={t.poster_image || undefined}
              autoPlay={autoplay}
              loop={loop}
              muted={autoplay}
              playsInline
              controls={!autoplay}
              className="w-full h-full object-cover"
            />
          )}
          <div className="absolute inset-0 bg-ink/45" />
        </div>
      )}
      {!embed && !t.poster_image && <div className="absolute inset-0 bg-sand" />}
      <div className="relative z-10 max-w-[640px] py-16">
        <RichText
          as="h2"
          className="font-display font-semibold text-[32px] md:text-[42px] leading-tight tracking-[-0.02em] text-white"
          html={t.heading}
        />
        {/* Boutons ajoutés depuis le Studio (blocs "cta_button") — cette
            section n'en affichait aucun jusqu'ici. */}
        {extraButtons.length > 0 && (
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <CtaButtonBlocks blocks={blocks} tone="dark" />
          </div>
        )}
      </div>
    </section>
  );
}
